export default {
    app: {
        titleName: 'BigC Employee Profile'
    },
    txt: {
        no: 'No.',
        profile: 'Profile',
        logout: 'Logout'
    },
    login: {
        username: 'Username',
        password: 'Password'
    },
    placeholder: {
        username: 'Username',
        password: 'Password'
    }
};
